"use client";
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../Component/ui/tabs";
import { PreventiveMaintenanceSection } from "../Component/sections/preventive-maintenance";
import { Activity } from "lucide-react";
import { BreakdownMaintenanceSection } from "../Component/sections/breakdown-maintenance";
import { AMCSection } from "../Component/sections/amc-section";
import { HumanResourceSection } from "../Component/sections/human-resource";
import { StatutoryApprovalsSection } from "../Component/sections/statutory-approvals";
import StockPRSection from "../Component/sections/stock-pr";
import {WorkPermitSection} from "../Component/sections/work-permit";
import { AuditsSection } from "../Component/sections/audits";
import { QCIndexSection } from "../Component/sections/qc-index";
import { MIIndexSection } from "../Component/sections/mi-index";
import "./MaintenanceDashboard.css";

export default function MaintenanceDashboard({ isSidebarExpanded }) {
  const [activeTab, setActiveTab] = useState("pm");
  const userName = localStorage.getItem("userName") || "User";

  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour < 12) {
      return "Good Morning";
    }

    if (hour < 18) {
      return "Good Afternoon";
    }

    return "Good Evening";
  };

  return (
    <div
      className={`dashboard  ${isSidebarExpanded ? "expanded" : "collapsed"}`}
    >
      <div className="data-form-content">
        <div className="newdashboard-min-h-screen">
          {/* Header */}
          <header className="newdashboard-header">
            <div className="newdashboard-header-container">
              <div className="newdashboard-header-flex">
                <Activity className="newdashboard-icon" />
                <div>
                  <h1 className="newdashboard-title">
                    {getGreeting()}, {userName}
                  </h1>
                  <p className="newdashboard-subtitle">
                    Comprehensive overview of all maintenance operations
                  </p>
                </div>
              </div>
            </div>
          </header>

          <div className="dashboard-container">
            <div className="dashboard-container-content dashboard_container_pd">
              {/* Main Content */}
              <main className="newdashboard-main-container">
                <Tabs value={activeTab} onValueChange={setActiveTab} className="newdashboard-tabs">
                  <TabsList className="newdashboard-tabs-list">
                    <TabsTrigger value="pm">PM</TabsTrigger>
                    <TabsTrigger value="breakdown">Breakdown</TabsTrigger>
                    <TabsTrigger value="amc">AMC</TabsTrigger>
                    <TabsTrigger value="hr">HR</TabsTrigger>
                    <TabsTrigger value="statutory">Statutory</TabsTrigger>
                    <TabsTrigger value="stock">PR/PO</TabsTrigger>
                    <TabsTrigger value="permit">Work Permit</TabsTrigger>
                    <TabsTrigger value="audits">Audits</TabsTrigger>
                    <TabsTrigger value="qc">QC Index</TabsTrigger>
                    <TabsTrigger value="mi">MI Index</TabsTrigger>
                  </TabsList>

                  <TabsContent
                    value="pm"
                    className="newdashboard-tabs-content"
                    index={0}
                  >
                    <PreventiveMaintenanceSection />
                  </TabsContent>

                  <TabsContent
                    value="breakdown"
                    className="newdashboard-tabs-content"
                    index={1}
                  >
                    <BreakdownMaintenanceSection />
                  </TabsContent>

                  <TabsContent value="amc" className="space-y-6" index={2}>
                    <AMCSection />
                  </TabsContent>

                  <TabsContent value="hr" className="space-y-6" index={3}>
                    <HumanResourceSection />
                  </TabsContent>

                  <TabsContent
                    value="statutory"
                    className="space-y-6"
                    index={4}
                  >
                    <StatutoryApprovalsSection />
                  </TabsContent>

                  <TabsContent value="stock" className="space-y-6" index={5}>
                    <StockPRSection />
                  </TabsContent>

                  <TabsContent value="permit" className="space-y-6" index={6}>
                    <WorkPermitSection />
                  </TabsContent>

                  <TabsContent value="audits" className="space-y-6" index={7}>
                    <AuditsSection />
                  </TabsContent>

                  <TabsContent value="qc" className="space-y-6" index={8}>
                    <QCIndexSection />
                  </TabsContent>

                  <TabsContent value="mi" className="space-y-6" index={9}>
                    <MIIndexSection />
                  </TabsContent>
                </Tabs>
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
